// splits a duration in seconds into whole hours and minutes (rounded to minutes)
export const splitDuration = (seconds) => {
  const totalMinutes = Math.round((seconds || 0) / 60)
  return {
    hours: Math.floor(totalMinutes / 60),
    minutes: totalMinutes % 60,
  }
}

// translation key for the kind of an input mismatch period
export const kindTranslationKey = (kind) =>
  kind === 'close_failed' ? 'map:valveFailure.close' : 'map:valveFailure.open'

// only periods of the given valve, newest first
export const periodsOfValve = (periods, valveId) =>
  (periods || [])
    .filter((period) => `${period.valveId}` === `${valveId}`)
    .sort((a, b) => new Date(b.startedAt) - new Date(a.startedAt))
